import type { AnalyzedMoveResult } from "@/shared/api/engine.api";

type MovePosition = Pick<AnalyzedMoveResult, "moveNumber" | "fenBefore" | "isPlayerMove">;
type PositionReference = { moveNumber: number; ply: number | null };

export const recordedPly = (move: Pick<MovePosition, "moveNumber" | "fenBefore">): number | null => {
  const side = move.fenBefore.split(" ")[1];
  if (!Number.isInteger(move.moveNumber) || move.moveNumber < 1 || (side !== "w" && side !== "b")) return null;
  return (move.moveNumber - 1) * 2 + (side === "w" ? 1 : 2);
};

export const findReferencedMoveIndex = (moves: readonly MovePosition[], reference: PositionReference): number => {
  if (reference.ply != null) return moves.findIndex((move) => recordedPly(move) === reference.ply);
  const playerIndex = moves.findIndex((move) => move.moveNumber === reference.moveNumber && move.isPlayerMove);
  return playerIndex >= 0 ? playerIndex : moves.findIndex((move) => move.moveNumber === reference.moveNumber);
};

export const movesInRange = <T extends Pick<MovePosition, "moveNumber">>(
  moves: readonly T[],
  range: { start: number; end: number },
): T[] => moves.filter((move) => move.moveNumber >= range.start && move.moveNumber <= range.end);
